import SoftwareUtils from "./common-utils.js";
import { CommonSoftwareModel, CommonSoftwareView, CommonSoftwareController } from "./common-software-mvc.js";

/**********************************************************************
 * Software Download MVC without Version Selection
 *********************************************************************/

// Inherit CommonSoftwareModel
export class CustomDownloadModel extends CommonSoftwareModel {
    constructor(filename) {
        super(filename);
    }
    
    // Object.defineProperty(CustomDownloadModel, 'constructor', {
    //     value: CustomDownloadModel,
    //     enumerable: false,
    //     writable: true,
    // });
    // CustomDownloadModel.prototype = Object.create(CustomDownloadModel.prototype);
}

export class CustomDownloadView extends CommonSoftwareView {
    constructor(model) {
        super(model);
        
        // resources, and versions are not applicable for the custom download.
        this.elements = SoftwareUtils.createChildrenCache([ 'error', 'eula', 'download' ]);
    }
    
    // Object.defineProperty(CustomDownloadView, 'constructor', {
    //     value: CustomDownloadView,
    //     enumerable: false,
    //     writable: true,
    // });
    
    // CustomDownloadView.prototype = Object.create(CommonSoftwareView.prototype);
    
    renderResult() {
        console.debug(`CustomDownloadView: renderResult(): version: ${this.model.version}`);
        
        // Track the version to be displayed.
        // Set to null since the download listing is independing of version.
        this.model.displayVersions = null;

        this.renderDownloads();
    }
}

export class CustomDownloadController extends CommonSoftwareController {
    constructor(model, view) {
        super(model, view);
    }
}
